import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MailboxContainer } from '@app/my-zone/shared/mailbox/mailbox.container';
import { TableListModule } from '@app/my-zone/shared/table-list/table-list.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { SwipeAnimationModule } from '@app/shared/ui/swipe-animation/swipe-animation.module';
import { CorrespondenceComponent } from './correspondence/correspondence.component';
import { DownloadComponent } from './correspondence/download/download.component';
import { MailboxComponent } from './mailbox.component';

@NgModule({
    declarations: [
        CorrespondenceComponent,
        DownloadComponent,
        MailboxComponent,
        MailboxContainer,
    ],
    imports: [
        CommonModule,
        PipesModule,
        SwipeAnimationModule,
        TableListModule,
    ],
    exports: [
        MailboxContainer,
    ],
})
export class MailboxModule {}
